
@if (isOpen()) {
  <div (click)="onBackdropClick($event)" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 animate-fade-in-fast">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-3xl p-6 text-slate-800 m-4 max-h-[90vh] flex flex-col">
      <div class="flex-shrink-0 flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold">{{ (device() ? 'modals.posDeviceForm.titleEdit' : 'modals.posDeviceForm.titleAdd') | translate }}</h2>
        <button (click)="onClose()" class="text-gray-400 hover:text-gray-600" title="Close modal">
          <i class="fa-solid fa-times text-xl"></i>
        </button>
      </div>
      
      <form [formGroup]="deviceForm" (ngSubmit)="onSave()" class="flex-grow overflow-y-auto pr-2 -mr-2 space-y-8">
        <!-- Device Details -->
        <fieldset class="space-y-4">
          <legend class="text-lg font-semibold text-gray-900 border-b pb-2 w-full mb-4">Device Details</legend>
          <div>
            <label for="name" class="block text-sm font-medium text-gray-700">{{ 'modals.posDeviceForm.name' | translate }}</label>
            <input id="name" type="text" formControlName="name" [placeholder]="'modals.posDeviceForm.namePlaceholder' | translate" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label for="storeId" class="block text-sm font-medium text-gray-700">{{ 'modals.posDeviceForm.store' | translate }}</label>
              <select id="storeId" formControlName="storeId" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
                @for(store of stores(); track store.id) {
                  <option [value]="store.id">{{ store.name }}</option>
                }
              </select>
            </div>
            <div>
              <label for="status" class="block text-sm font-medium text-gray-700">{{ 'modals.posDeviceForm.status' | translate }}</label>
              <select id="status" formControlName="status" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
                <option value="active">{{ 'modals.posDeviceForm.statusActive' | translate }}</option>
                <option value="inactive">{{ 'modals.posDeviceForm.statusInactive' | translate }}</option>
              </select>
            </div>
          </div>
        </fieldset>

        <!-- Printer Settings -->
        <fieldset formGroupName="printerSettings" class="space-y-4">
          <legend class="text-lg font-semibold text-gray-900 border-b pb-2 w-full mb-4">Printer Settings</legend>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label for="connectionType" class="block text-sm font-medium text-gray-700">การเชื่อมต่อ</label>
              <select id="connectionType" formControlName="connectionType" class="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm">
                @for(type of connectionTypes; track type) {
                  <option [value]="type">{{ type }}</option>
                }
              </select>
            </div>
             @if(deviceForm.get('printerSettings.connectionType')?.value === 'ETHERNET') {
              <div>
                <label for="ipAddress" class="block text-sm font-medium text-gray-700">ที่อยู่ IP ของเครื่องพิมพ์</label>
                <input id="ipAddress" type="text" formControlName="ipAddress" placeholder="192.168.1.100" class="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm">
                @if(deviceForm.get('printerSettings.ipAddress')?.hasError('pattern')) {
                  <p class="text-xs text-red-600 mt-1">Invalid IP address format.</p>
                }
              </div>
             }
          </div>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
             <div>
                <label for="printerModel" class="block text-sm font-medium text-gray-700">รุ่นของเครื่องพิมพ์</label>
                <select id="printerModel" formControlName="model" class="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm">
                  @for(model of printerModels; track model) {
                    <option [value]="model">{{ model }}</option>
                  }
                </select>
              </div>
              <div>
                <label for="paperWidth" class="block text-sm font-medium text-gray-700">ความกว้างของกระดาษ</label>
                <select id="paperWidth" formControlName="paperWidth" class="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm">
                   @for(width of paperWidths; track width) {
                    <option [value]="width">{{ width }}</option>
                  }
                </select>
              </div>
          </div>
          
          <div class="flex items-center justify-between pt-2">
            <span class="text-sm font-medium text-gray-700" id="autoPrintLabel">พิมพ์ใบเสร็จและบิล</span>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" formControlName="autoPrint" aria-labelledby="autoPrintLabel" class="sr-only peer">
              <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
            </label>
          </div>
          <div class="flex items-center justify-between pt-2">
            <span class="text-sm font-medium text-gray-700" id="advancedSettingsLabel">การตั้งค่าขั้นสูง</span>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" formControlName="advancedSettingsEnabled" aria-labelledby="advancedSettingsLabel" class="sr-only peer">
              <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
            </label>
          </div>

          <!-- Advanced Printer Settings -->
          @if(deviceForm.get('printerSettings.advancedSettingsEnabled')?.value) {
            <fieldset formGroupName="advancedSettings" class="space-y-4 bg-slate-50 p-4 rounded-md border animate-fade-in-fast">
              <legend class="text-md font-semibold text-gray-900 w-full mb-2">Advanced ESC/POS Settings</legend>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div><label for="printMode" class="block text-sm font-medium text-gray-700">โหมดพิมพ์</label><select id="printMode" formControlName="printMode" class="mt-1 w-full text-sm rounded-md"><option>GRAPHIC</option><option>TEXT</option></select></div>
                <div><label for="printWidth" class="block text-sm font-medium text-gray-700">ความกว้างการพิมพ์</label><select id="printWidth" formControlName="printWidth" class="mt-1 w-full text-sm rounded-md"><option>80mm</option><option>72mm</option><option>58mm</option></select></div>
                <div><label for="printResolution" class="block text-sm font-medium text-gray-700">ความละเอียดการพิมพ์</label><select id="printResolution" formControlName="printResolution" class="mt-1 w-full text-sm rounded-md"><option>203dpi</option><option>180dpi</option></select></div>
              </div>
              <div><label for="initialCommand" class="block text-sm font-medium text-gray-700">คำสั่งเริ่มต้น</label><input id="initialCommand" type="text" formControlName="initialCommand" class="mt-1 w-full font-mono text-sm rounded-md"></div>
              <div><label for="cutterCommand" class="block text-sm font-medium text-gray-700">คำสั่งตัดกระดาษ</label><input id="cutterCommand" type="text" formControlName="cutterCommand" class="mt-1 w-full font-mono text-sm rounded-md"></div>
              <div><label for="drawerCommand" class="block text-sm font-medium text-gray-700">คำสั่งลิ้นชัก</label><input id="drawerCommand" type="text" formControlName="drawerCommand" class="mt-1 w-full font-mono text-sm rounded-md"></div>
            </fieldset>
          }
        </fieldset>
        
        <div class="flex-shrink-0 pt-6 border-t flex justify-between items-center">
           <button (click)="onTestPrint()" type="button" class="bg-slate-600 hover:bg-slate-700 text-white font-semibold py-2.5 px-5 rounded-lg transition-colors flex items-center gap-2">
            <i class="fa-solid fa-print"></i><span>Test Print</span>
          </button>
          <div class="flex space-x-3">
            <button type="button" (click)="onClose()" class="bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300 font-semibold transition-colors">{{ 'common.cancel' | translate }}</button>
            <button type="submit" [disabled]="deviceForm.invalid" class="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700 disabled:bg-emerald-300 font-semibold transition-colors">{{ 'modals.productForm.save' | translate }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
